import React, { Component } from 'react'

import { TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import View from 'react-flexbox'
export function dateToString(data) {
    if (!data) {
        return "";
    }
    try {
        data = data.toDate()
    } catch (error) {
        try {
            data = new Date(data.seconds * 1000)
        } catch (error) {

        }
    }
    try {


        var mm = data.getMonth() + 1; // getMonth() is zero-based
        var dd = data.getDate();
        var minutes = data.getMinutes();
        var hour = data.getHours();
        return [
            (dd > 9 ? '' : '0') + dd,
            (mm > 9 ? '' : '0') + mm,
            data.getFullYear(),
        ].join('/') + " " + hour + ":" + minutes;
    } catch (error) {

        console.log('error', error);
        console.log('data', data);

        return "erro"

    }
}
class ItemComentario extends Component {
    componentDidMount() {
        this.props.listar();
    }
    render() {

        const { comentario, classes, nomeUsuario } = this.props
        return (
            <Card className={classes.card}>
                <TextField
                    className={classes.cardContent}
                    disabled
                    multiline
                    value={comentario.texto}
                    fullWidth
                    InputProps={{
                        style: { color: "#000" }
                    }}
                />
                <View style={{ paddingLeft: 5, paddingRight: 10 }}>

                    <Typography variant="caption" className={classes.cardData}>{dateToString(comentario.data)}</Typography>
                    <Typography variant="caption" className={classes.cardData}>{nomeUsuario || comentario.userUid}</Typography>
                </View>
            </Card>
        )
    }
}
const styles = {
    card: {
        // maxWidth: 500,
        margin: 3,
    },

    cardContent: {
        paddingLeft: 5,
        paddingTop: 5,
        paddingRight: 5,

    },
    cardData: {
        paddingLeft: 5,


    },

};

export default withStyles(styles)(ItemComentario);



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Comentarios/components/ItemComentario/ItemComentario.js